module.exports = __webpack_public_path__ + "static/img/industrial.c907c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/industrial.png
// module id = TyKf
// module chunks = 11